export function replaceFenColor(fen?: string, color?: 'b' | 'w') {
  if (!fen) {
    return fen;
  }

  return fen.replace(/ (w|b) /g, ` ${color ?? 'w'} `);
}
